import { Component } from 'react';
import validation from 'Helpers/Validation';
import { validator } from 'Helpers/validator';
import LoadingOverlay from 'react-loading-overlay';

export default class SendMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupName: this.props.groupName,
      message: '',
      loading: false,
      showError: false,
      errorElement: '',
    };
    this.validator = validator.getInstance();
  }

  /**
   * @method validation
   * @summary validate the inputs based on validation rules
   * @param {event} event - React onBlur event
   * @return {none} undefined
   */

  validation = (e) => {
    validation(e, 'send-message-form');
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [ name ]: value });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.errorElement !== this.props.errorElement) {
      this.setState({ errorElement: this.props.errorElement });
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const formId = event.target.id;
    const { groupName, message } = this.state;
    this.setState({ showError: false }, () => {
      if (formId && !this.validator.checkBeforeSubmit(formId) && this.state.showError !== true) {
        //console.log('message', message)
      }
    });
  };  

  closeForm = () => {
    this.props.closeForm()
  }

  render() {
    const { message, errorElement, groupName } = this.state;
    const { formLoading, name } = this.props;
    return (
      <>
        <div className='addbroadcast saveDomain open'>
          <div className='overlay' onClick={ this.closeForm }></div>
          <div className='addmgnt'>
            <LoadingOverlay
              active={ formLoading }
              spinner
              styles={ {
                wrapper: {
                  width: '100%',
                  textAlign: '-webkit-center',
                },
              } }
              text='Please wait...'
            ></LoadingOverlay>
            <div className='head'>
              <h2>{`Send Message To: ${ groupName ? groupName : '' }` }</h2>
            </div>
            <div className='form'>
              <form
                id='send-message-form'
                autoComplete='off'
                onSubmit={ this.handleSubmit }
              >
                <div className='formgroup new'>
                  <label>
                    Message<sup>*</sup>
                  </label>
                  <input
                    type='text'
                    name='message'
                    value={ message }
                    data-validation={ [ 'requiredfield' ] }
                    placeholder='Enter message here!'
                    data-error='Enter message'
                    onBlur={ this.validation }
                    onChange={ this.handleChange }
                  />
                </div>
                {errorElement && (
                  <span className='errorElement'>{errorElement}</span>
                )}
                <div className='buttons'>
                  <div>
                    <button
                      type='reset'
                      onClick={ this.closeForm }
                      className='btn btn_outline'
                    >
                      Cancel
                    </button>
                    <button className='btn btn_primary'>Send</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}
